import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const OrderPackage = ApplicationRecord.extend({
  static: {
    jsonapiType: 'order_packages',
  },
  attrs: {
    url: attr(),
    pose: attr(),
    grad: attr(),
    price: attr(),
    scanned: attr(),
    quantity: attr(),
    emailPicture: attr(),
    isPreviewHidden: attr(),
    appointmentTime: attr(),
    schoolId: attr(),
    emailSent: attr({ persist: false }),
    createdAt: attr({ persist: false }),
    updatedAt: attr({ persist: false }),
    extraPoses: attr(),
    cartId: attr(),
    studentId: attr(),
    optionId: attr(),
    // Read-only, mirroring Api::OrderPackageResource's writable:false block — the server
    // rejects any client write. persist:false keeps spraypaint from ever putting it in a
    // payload (a dirtied buyAll would turn an unrelated save into a 4xx).
    buyAll: attr({ persist: false }),
    packageId: attr(),
    backgroundId: attr(),
    studentImageId: attr(),
    seniorImageId: attr(),
    poseId: attr(),
    downloadImageId: attr(),
    shipperInitials: attr(),
    shipDate: attr(),
    shipDestination: attr(),
    isUpgrade: attr(),
    cart: belongsTo(),
    hasNameOnCover: attr(),
    apiOption: belongsTo(),
    options: hasMany(),
    package: belongsTo(),
    seniorImage: belongsTo(),
    student: belongsTo(),
    studentImage: belongsTo(),
    background: belongsTo(),
    extras: hasMany(),
    sheets: hasMany(),
    addonSheets: hasMany(),
    firstPoseUrl: attr({ persist: false }),
    hasDownloadableImages: attr(),
    backgroundWasResubmitted: attr(),
    onHold: attr(),
    onHoldReason: attr(),
    orderPackageExtras: hasMany(),
    hasDigitalYearbook: attr(),
    appointmentSeason: attr(),
  },
  methods: {
    option: function() {
      if (this.optionId) return this.apiOption;

      return this.options && this.options[0];
    },
    total() {
      return this.price + this.extras.reduce((acc, extra) => acc + extra.price(), 0)
    },
  },
})

export default OrderPackage
